import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "proposal-date__item" }
const _hoisted_2 = { class: "proposal-date__icon" }
const _hoisted_3 = { class: "proposal-date__action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemIcon = _resolveComponent("ItemIcon")!
  const _component_DestroyIcon = _resolveComponent("DestroyIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ItemIcon)
    ]),
    _createElementVNode("div", {
      class: "proposal-date__content",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('dateFocus')))
    }, _toDisplayString($options.formattedDate), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_DestroyIcon, {
        title: $options.t('calendar', 'Remove date'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('dateRemove')))
      }, null, 8, ["title"])
    ])
  ]))
}